import React, { useState } from "react";
import { ArrowDown, ChevronLeft, ChevronRight } from "lucide-react";
import { interiorImage, interiorImage2, interiorImage3 } from "../mock/data";

const slides = [
  { src: interiorImage, alt: "Dr. Khurana's Dental Clinic — reception & waiting area, Chhatameel Lucknow" },
  { src: interiorImage2, alt: "Dr. Khurana's Dental Clinic — treatment room, Chhatameel Lucknow" },
  { src: interiorImage3, alt: "Dr. Khurana's Dental Clinic — dental chair & awards wall, Chhatameel Lucknow" },
];

export default function About() {
  const [idx, setIdx] = useState(0);
  const total = slides.length;
  const prev = () => setIdx((i) => (i - 1 + total) % total);
  const next = () => setIdx((i) => (i + 1) % total);

  return (
    <section id="about" className="relative py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-8 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-6 reveal">
          <div className="section-eyebrow">Dr. Khurana&rsquo;s Dental &amp; Aesthetic Clinic</div>
          <h2 className="mt-5 font-serif-display text-[40px] md:text-[58px] leading-[1.05] text-[#0e2b2b]">
            A space designed<br />for your <span className="hero-italic">comfort &amp; confidence</span>
          </h2>
          <p className="mt-6 text-[15px] md:text-[16px] text-[#0e2b2b]/70 leading-relaxed max-w-[540px]">
            Founded with one clear vision — to make exceptional dental care accessible, comfortable and stress-free for every patient in Lucknow. Our clinic features a cozy, contemporary ambiance, strict patient privacy standards, and the most advanced treatment technology available.
          </p>
          <p className="mt-4 text-[15px] md:text-[16px] text-[#0e2b2b]/70 leading-relaxed max-w-[540px]">
            We treat every visit as a personal experience. Whether you&rsquo;re here for a routine check-up or a full smile transformation, you&rsquo;ll always be greeted by a warm team that genuinely cares.
          </p>
          <div className="mt-8">
            <a href="#contact" className="btn-primary">Visit the Clinic <ArrowDown size={16} /></a>
          </div>
        </div>

        <div className="lg:col-span-6 reveal">
          <div className="relative aspect-[5/6] w-full rounded-[36px] overflow-hidden bg-[#0a1f1f] group">
            {slides.map((s, i) => (
              <img
                key={s.src}
                src={s.src}
                alt={s.alt}
                className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ease-out ${i === idx ? "opacity-100" : "opacity-0"}`}
              />
            ))}

            {/* Established badge */}
            <div className="absolute top-5 right-5 bg-white/95 backdrop-blur rounded-2xl px-5 py-4 shadow-lg z-10">
              <div className="text-[11px] tracking-[0.22em] uppercase text-[#14a68e] font-semibold">Established 2022</div>
              <div className="font-serif-display text-[22px] text-[#0e2b2b] mt-1">5+ years of care</div>
            </div>

            {/* Navigation */}
            <div className="absolute inset-x-0 bottom-4 flex items-center justify-between px-4 z-10">
              <button
                onClick={prev}
                aria-label="Previous photo"
                className="inline-flex items-center gap-2 pl-2 pr-4 py-2 rounded-full bg-white/95 backdrop-blur text-[#0e2b2b] shadow-md hover:bg-[#14a68e] hover:text-white transition text-[12px] font-semibold uppercase tracking-wide"
              >
                <span className="w-7 h-7 rounded-full bg-[#eaf6f2] flex items-center justify-center"><ChevronLeft size={16} /></span>
                Previous
              </button>

              {/* Dots */}
              <div className="flex items-center gap-1.5">
                {slides.map((_, i) => (
                  <button
                    key={i}
                    onClick={() => setIdx(i)}
                    aria-label={`Photo ${i + 1}`}
                    className={`h-1.5 rounded-full transition-all ${i === idx ? "w-6 bg-white" : "w-2 bg-white/50 hover:bg-white/80"}`}
                  />
                ))}
              </div>

              <button
                onClick={next}
                aria-label="Next photo"
                className="inline-flex items-center gap-2 pl-4 pr-2 py-2 rounded-full bg-white/95 backdrop-blur text-[#0e2b2b] shadow-md hover:bg-[#14a68e] hover:text-white transition text-[12px] font-semibold uppercase tracking-wide"
              >
                Next
                <span className="w-7 h-7 rounded-full bg-[#eaf6f2] flex items-center justify-center"><ChevronRight size={16} /></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
